export default {
  logo_text: 'EMP',
  sidebar_index: 'Index',
  sidebar_auth: 'User',
  sidebar_crm: 'Custom',
  sidebar_sys: 'System',
  sidebar_order: 'Order',
  sidebar_app: 'App'
}
